<template>
  <div>
    <div
      class="backdrop-blur-2xl absolute inset-0 z-10 select-none bg-black/80"
    ></div>
    <img
      :src="slides[activeIndex].path"
      class="absolute inset-0 z-0 size-full object-cover select-none"
      alt=""
    />
    <swiper
      :slidesPerView="'auto'"
      :loop="false"
      :centeredSlides="false"
      :pagination="{
        clickable: true,
      }"
      class="mySwiper !overflow-visible h-[300px] md:h-[600px] relative !z-20 select-none"
      :onSlideChange="onSlideChange"
    >
      <swiper-slide
        v-for="(media, i) in slides"
        class="first:border-l last:border-r border-black/20 [&.swiper-slide-active]:z-10 [&.swiper-slide-active]:shadow-2xl [&.swiper-slide-active_.blurred]:opacity-0"
      >
        <div
          class="blurred absolute inset-0 bg-black/80 backdrop-blur-sm opacity-100 transition-opacity duration-500"
        ></div>
        <img
          class="size-full object-cover object-[0%_30%]"
          :src="
            media['gallery-optimized'] ||
            media['default-optimized'] ||
            media.path
          "
          alt=""
        />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script setup>
import 'keen-slider/keen-slider.min.css'
import { useKeenSlider } from 'keen-slider/vue.es'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue'
import { ref } from 'vue'

import ImagePlaceholder from '@/components/ImagePlaceholder.vue'
import { previewToDataURL } from '@/utils/thumbhash.js'

// import './style.css'

const props = defineProps({
  slides: {
    type: Array,
    default: [],
  },
})

const options = {
  mode: 'free-snap',
  loop: {
    min: -5,
    max: 5,
  },
  slides: {
    origin: 'center',
    perView: 3,
  },
  slideChanged: (s) => {
    console.log(container)
    // this.current = s.track.details.rel
  },
  renderMode: 'performance',
}
const activeIndex = ref(0)

function onSlideChange(e) {
  activeIndex.value = e.activeIndex
  console.log(e.activeIndex)
}

const indexes = ref([])
const [container] = useKeenSlider({
  initial: 0,
  loop: false,
  mode: 'free-snap',
  detailsChanged: (s) => {
    indexes.value = s.track.details.slides.map((slide) => {
      return slide.abs
    })
  },
  slides: {
    origin: 'center',
    perView: 2,
  },
})
</script>
